<template>
  <GalleryPage />
</template>
<script>
import GalleryPage from "@/components/GalleryPage.vue";
const components = {
  GalleryPage,
};
export default {
  name: "gallery",
  components,
};
</script>
